import { render, staticRenderFns } from "./task.vue?vue&type=template&id=1cdc5ab4"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=1cdc5ab4&prod&lang=less"
import style1 from "./task.vue?vue&type=style&index=1&id=1cdc5ab4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports